import assign from 'lodash/assign';

import { AddLink } from './addLink';
import { AddUrl } from './addUrl';
import { SelectItem } from './selectItem';
import { SelectItemType } from './selectItemType';
import { AddItem } from './addItem/addItem';
import './addToMenu.scss';

export const AddToMenu = angular
    .module('app.pages.editstore.menuEditor.addToMenu', [
        AddLink,
        AddUrl,
        SelectItem,
        SelectItemType,
        AddItem
    ]).component('menuEditorAddToMenu', {
        template: `

            <menu-editor-select-item-type
                ng-if="$ctrl.menuState === 'selectItemType'"
                blacklist-types="$ctrl.blacklistTypes"
                on-item-selected="$ctrl.onMenuItemTypeSelected(type)"
                class="menu-editor-list">
            </menu-editor-select-item-type>

            <menu-editor-select-item
                ng-if="$ctrl.menuState === 'selectItem'"
                type="$ctrl.addItemType"
                on-back-button-click="$ctrl.showSelectItemType"
                on-menu-item-selected="$ctrl.onItemSelected"
                on-add-item-click="$ctrl.showAddItemType">
            </menu-editor-select-item>

            <menu-editor-add-link
                ng-if="$ctrl.menuState === 'addLink'"
                on-cancel-click="$ctrl.showSelectItemType()"
                on-link-saved="$ctrl.onItemSelected({ newItem: item, itemType: 'link' })">
            </menu-editor-add-link>

            <menu-editor-add-url
                ng-if="$ctrl.menuState === 'addUrl'"
                on-cancel-click="$ctrl.showSelectItemType()"
                on-url-saved="$ctrl.onItemSelected({ newItem: item, itemType: 'externalUrl' })">
            </menu-editor-add-url>

            <menu-editor-add-item
                ng-if="$ctrl.menuState === 'addItem'"
                type="$ctrl.addItemType"
                on-back-button-click="$ctrl.onMenuItemTypeSelected"
                on-save-click="$ctrl.onMenuItemTypeSelected">
            </menu-editor-add-item>
        `,
        bindings: {
            onItemSelected: '<',
            blacklistTypes: '<'
        },
        controller: class MenuEditorAddToMenuCtrl {
            constructor() {
                'ngInject';

                assign(this, {
                    menuState: 'selectItemType'
                });

                this.showAddItemType = this.showAddItemType.bind(this);
                this.onMenuItemTypeSelected = this.onMenuItemTypeSelected.bind(this);
                this.showSelectItemType = this.showSelectItemType.bind(this);
            }

            onMenuItemTypeSelected(type) {
                this.addItemType = type;
                switch (type) {
                    case 'link':
                        this.menuState = 'addLink';
                        break;
                    case 'externalUrl':
                        this.menuState = 'addUrl';
                        break;
                    default:
                        this.menuState = 'selectItem';
                        break;
                }
            }

            showSelectItemType() {
                this.menuState = 'selectItemType';
            }

            showAddItemType(type) {
                this.addItemType = type;
                this.menuState = 'addItem';
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/menuEditor/addToMenu.js